<app-dialog-header [header]="'agr.archival' | loc"></app-dialog-header>
<div class="font-16 padding-bottom-10">
  {{ 'agr.agrRef' | loc }}: <b> {{ agreementData.agreementNumber }} </b>
</div>
<div class="font-14 padding-bottom-15" *ngIf="agreementData as agr">
  {{ 'label.startDate' | locCap }}:
  <b>
    {{ agr.agreementStartDate | dateTo: agr.agreementEndDate:{ toNullValue: ('label.infiniteAgr' | loc) } }}
  </b>
</div>
<div>
  <span> {{ 'agr.archiveDate' | locCap }} </span>
  <app-date-input [formControl]="dateForm" [min]="getMinDate()" [max]="getMaxDate()"></app-date-input>
</div>
<div>
  <span>{{ 'label.notes' | locCap }} ({{ 'label.optional' | loc }})</span>
  <app-text-input type="textarea" [formControl]="noteForm"></app-text-input>
</div>
<div class="submit-button">
  <button mat-stroked-button class="fliko-stroked-button" (click)="submit()">{{ 'button.archive' | loc }}</button>
</div>
